import React from 'react';
import Landing from '../pages/landing/Landing';

const MainLayout = () => <Landing />;

export default MainLayout;
